import "./skills.css";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { assetsMap, imageInitializer } from "../../model/assets.js";
import tileAnimation from "../../assets/tileAnimation.svg";
import download from "../../assets/download.svg";
import content from "../../assets/content.svg";
import { Navigation } from '../home/navigation/navigation';

let lookingTimeout;

export const ServicesHome = () => {
    const [animateOpen, setAnimateOpen] = useState(false);
    const [looking, setLooking] = useState(true);
    const history = useNavigate();
    const [assets, setAssets] = useState(assetsMap);
    const animationOpen = () => {
        if (!animateOpen) {
            const tile = document.querySelector(".animationTile:nth-child(2)");
            tile.style.width = tile.getBoundingClientRect().width + "px";
            tile.style.height = tile.getBoundingClientRect().height + "px";
            tile.style.inset = tile.getBoundingClientRect().top + "px auto auto " + tile.getBoundingClientRect().left + "px";
            setTimeout(() => {
                setAnimateOpen(true);
                setTimeout(() => history('../animation'), 220);
            }, 0);
        }
    }
    const onEnter = () => {
        lookingTimeout = setTimeout(() => setLooking(false), 600);
    }
    const onLeave = () => {
        clearTimeout(lookingTimeout);
        setLooking(true);
    }
    const cv_file = useIntl().messages.cv_file;
    useEffect(() => {
        let timeout = imageInitializer(setAssets);
        return () => {
            clearTimeout(timeout);
        }
    }, [assets, setAssets]);
    return (
        <div className="view services standalone">
            <div className="hiddenForLoading">
                <img draggable="false" alt="" src={tileAnimation}/>
            </div>
            <Navigation/>
            <div className="action top left align-center">
                <Link to={"../home"}><button className="reveal reveal-area action round align-center"><img draggable="false" alt="" width="35" height="35" src="https://saison.one/assetsCommon/navigation_arrow.svg"/></button></Link>
                <Link to={"../portfolio"}><button className="reveal reveal-area round action align-center"><img draggable="false" alt="" width="30" height="30" src={ content }/><span className="optimizeSmall"><FormattedMessage id="titlePortfolio"/></span></button></Link>
            </div>
            <h2><FormattedMessage id="services"/></h2>
            <div className="tile_root">
                <div className="tile_container">
                    <div className="item align-center" style={{animationDelay: "0s", background: `url(${assets.patternCoffee.file})`}}>
                        <span><FormattedMessage id="brandIdentity"/></span>
                        <Link to="../brandidentity"/>
                    </div>
                    <div className="tile_container small">
                        <div onClick={animationOpen} className="item align-center animationTile" style={{animationDelay: "0.1s"}}>
                            <span>Ani<br/>mat<br/>ion</span>
                        </div>
                        { animateOpen && <div className="item"/> }
                        <div onClick={animationOpen} className={`item align-center animationTile ${animateOpen ? "animateOpen" : ""}`} style={{animationDelay: "0.1s" , background: animateOpen ? `url(${tileAnimation}) #fe4406` : `url(${assets.tileAnimation.file})`}}/>
                        <div className="item align-center" style={{animationDelay: "0.2s"}}>
                            <span style={{fontSize: "5.2vmin"}}>Pack<br/>aging</span>
                            <Link to="../packaging"/>
                        </div>
                        <div className="item" style={{animationDelay: "0.3s", background: `url(${assets.noriPastaFront.file})`, backgroundPosition: "center"}}>
                            <Link to="../gallery/view?id=noriPastaFront&origin=services"/>
                        </div>
                    </div>
                    <div className="tile_container small">
                        <div className="item align-center" style={{animationDelay: "0.3s"}}>
                            <span style={{fontSize: "5vmin"}}><FormattedMessage id="br_exp" values={{rtn: <br/>}}/></span>
                            <Link to="../experimentations"/>
                        </div>
                    </div>
                    <div className="item align-center" style={{animationDelay: "0.4s", background: "url('./assets/website/photoTile.jpg')"}}>
                        <span><FormattedMessage id="photography"/></span>
                        <Link to="../photography?origin=services"/>
                    </div>
                </div>
                <div className="tile_container">
                <div className="item align-center" style={{animationDelay: "0.3s", background: `url(${assets.layoutExampleMini.file})`, backgroundPosition: "center"}}>
                        <span><FormattedMessage id="layout"/></span>
                        <Link to="../layout"/>
                    </div>
                    <div className="item align-center" style={{animationDelay: "0.4s", background: `url(${assets.mockupTypoLow.file})`, backgroundPosition: "left"}}>
                        <span><FormattedMessage id="typography"/></span>
                        <Link to="../typography"/>
                    </div>
                    <div className="tile_container small">
                        <div className="item align-center" style={{animationDelay: "0.2s", background: "#3b4240"}} onMouseEnter={ onEnter } onMouseLeave={ onLeave }>
                            {
                                looking ?
                                    <span className="lookingFor"><FormattedMessage id="internship"/></span>
                                :
                                    <span className="lookingFor animate"><FormattedMessage id="contact_me"/></span>
                            }
                            { !looking && <a href="mailto:remy.jeuniaux@icloud.com"> </a>}
                            <img className="inviteCv" alt="" src="./assets/website/remyVitaliAmand.jpeg" />
                        </div>
                        <div className="item align-center cvButton" style={{animationDelay: "0.4s", background: "#3b4240"}}>
                            <img draggable="false" alt="" src={download}/>
                            <span style={{fontSize: "7vmin"}}><FormattedMessage id="br_cv" values={{rtn: <br/>}}/></span>
                            <a href={`./content/${cv_file}.pdf`} download> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}